export enum VexMonitoredAction {
  AuthExchange = 'vex_auth_exchange',
  PaymentUpgradeSubmit = 'vex_payment_upgrade_submit',
}
